/*
TRANE CONFIDENTIAL

2021 – 2022 Copyright Trane U.S. Inc.
All Rights Reserved.

NOTICE: All information contained herein is, and remains the property of
Trane U.S. Inc. The source code, object code, intellectual and technical
concepts contained herein are proprietary to Trane U.S. Inc. and may be
covered by patents and patent applications and are protected by trade secret
and copyright law. Dissemination of this information or reproduction of this
material is strictly forbidden unless prior written permission is obtained
from Trane U.S. Inc. Do not use this software without the prior written
permission of Trane U.S. Inc.
*/

import * as React from "react";
import PropTypes from "prop-types";
import Theme from "../../Theme";
import prefixStyles from "../../utils/prefixStyles";

export default class LabelField extends React.Component {
  static propTypes = {
    label: PropTypes.string.isRequired,
    description: PropTypes.string,
    labelStyle: PropTypes.object,
    style: PropTypes.object,
  };

  render() {
    const styles = prefixStyles({
      label: {
        flex: "0 0 auto",
        display: "flex",
        alignItems: "center",
        maxWidth: "100%",
        fontWeight: "bold",
        justifyContent: "center",
      },
    });
    const { label, style } = this.props;

    return (
      <div data-component-name="LabelField" style={style}>
        <div style={{ padding: Theme.Padding.CONTENT }}>
          <div style={styles.label}>{label}</div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ../nx-components/src/Form/fields/LabelField.jsx